import XEUtils from 'xe-utils';
import { VxeUI } from '../../../ui';
import { toFilters, handleFieldOrColumn, getRefElem } from '../../src/util';
import { getDomNode, triggerEvent } from '../../../ui/src/dom';
import { isEnableConf } from '../../../ui/src/utils';
const { renderer } = VxeUI;
export default {
    methods: {
        /**
         * 手动弹出筛选面板
         * @param column
         */
        _openFilter(fieldOrColumn) {
            const column = handleFieldOrColumn(this, fieldOrColumn);
            if (column && column.filters) {
                const { elemStore } = this;
                const { fixed } = column;
                return this.scrollToColumn(column).then(() => {
                    const headerWrapperElem = elemStore[`${fixed || 'main'}-header-wrapper`] || elemStore['main-header-wrapper'];
                    if (headerWrapperElem) {
                        const filterBtnElem = headerWrapperElem.querySelector(`.vxe-header--column.${column.id} .vxe-filter--btn`);
                        triggerEvent(filterBtnElem, 'click');
                    }
                });
            }
            return this.$nextTick();
        },
        /**
         * 修改筛选条件列表
         * @param {ColumnInfo} fieldOrColumn 列
         * @param {Array} options 选项
         */
        _setFilter(fieldOrColumn, options, isUpdate) {
            const $xeTable = this;
            const column = handleFieldOrColumn(this, fieldOrColumn);
            if (column && column.filters) {
                column.filters = toFilters(options || []);
                if (isUpdate) {
                    return $xeTable.handleColumnConfirmFilter(column, new Event('click'));
                }
            }
            return $xeTable.$nextTick();
        },
        checkFilterOptions() {
            const { filterStore } = this;
            filterStore.isAllSelected = filterStore.options.every((item) => item._checked);
            filterStore.isIndeterminate = !filterStore.isAllSelected && filterStore.options.some((item) => item._checked);
        },
        /**
         * 点击筛选事件
         * 当筛选图标被点击时触发
         * 更新选项是否全部状态
         * 打开筛选面板
         * @param {Event} evnt 事件
         * @param {ColumnInfo} column 列配置
         * @param {Object} params 参数
         */
        triggerFilterEvent(evnt, column, params) {
            const $xeTable = this;
            const reactData = $xeTable;
            const internalData = $xeTable;
            const { filterStore } = this;
            if (filterStore.column === column && filterStore.visible) {
                filterStore.visible = false;
            }
            else {
                const { initStore, filterStore } = reactData;
                const { elemStore } = internalData;
                if (filterStore.column === column && filterStore.visible) {
                    filterStore.visible = false;
                }
                else {
                    const { clientY, pageX } = evnt;
                    const el = $xeTable.$refs.refElem;
                    const tableRect = el.getBoundingClientRect();
                    const targetElem = evnt.target;
                    const { visibleWidth } = getDomNode();
                    const { filters, filterMultiple, filterRender } = column;
                    const compConf = isEnableConf(filterRender) ? renderer.get(filterRender.name) : null;
                    const frMethod = column.filterRecoverMethod || (compConf ? (compConf.tableFilterRecoverMethod || compConf.filterRecoverMethod) : null);
                    internalData._currFilterParams = params;
                    Object.assign(filterStore, {
                        multiple: filterMultiple,
                        options: filters,
                        column,
                        style: null
                    });
                    // 复原状态
                    filterStore.options.forEach((option) => {
                        const { _checked, checked } = option;
                        option._checked = checked;
                        if (!checked && _checked !== checked) {
                            if (frMethod) {
                                frMethod({ option, column, $table: $xeTable });
                            }
                        }
                    });
                    this.checkFilterOptions();
                    filterStore.visible = true;
                    initStore.filter = true;
                    $xeTable.$nextTick(() => {
                        const headerScrollElem = getRefElem(elemStore['main-header-scroll']);
                        if (!headerScrollElem) {
                            return;
                        }
                        const tableFilter = $xeTable.$refs.refTableFilter;
                        const filterWrapperElem = tableFilter ? tableFilter.$el : null;
                        if (!filterWrapperElem) {
                            return;
                        }
                        const filterWidth = filterWrapperElem.offsetWidth;
                        const filterHeadElem = filterWrapperElem.querySelector('.vxe-table--filter-header');
                        const filterFootElem = filterWrapperElem.querySelector('.vxe-table--filter-footer');
                        const centerWidth = filterWidth / 2;
                        const minMargin = 10;
                        const maxLeft = el.clientWidth - filterWidth - minMargin;
                        let left, right;
                        const thEl = targetElem.offsetParent;
                        const trEl = thEl.offsetParent;
                        const style = {
                            top: `${targetElem.offsetTop + thEl.offsetTop + targetElem.offsetHeight}px`
                        };
                        // 判断面板不能大于表格高度
                        const maxHeight = Math.max(40, el.clientHeight - (clientY - tableRect.y) - (filterHeadElem ? filterHeadElem.clientHeight : 0) - (filterFootElem ? filterFootElem.clientHeight : 0) - 14);
                        if (column.fixed === 'left') {
                            left = targetElem.offsetLeft + thEl.offsetLeft - centerWidth;
                        }
                        else if (column.fixed === 'right') {
                            right = (thEl.offsetWidth - targetElem.offsetLeft) + (trEl.offsetWidth - trEl.offsetLeft) - column.renderWidth - centerWidth;
                        }
                        else {
                            left = targetElem.offsetLeft + thEl.offsetLeft - centerWidth - headerScrollElem.scrollLeft;
                        }
                        if (left) {
                            const overflowWidth = (pageX + filterWidth - centerWidth + minMargin) - visibleWidth;
                            if (overflowWidth > 0) {
                                left -= overflowWidth;
                            }
                            style.left = `${Math.min(maxLeft, Math.max(minMargin, left))}px`;
                        }
                        else if (right) {
                            const overflowWidth = (pageX + filterWidth - centerWidth + minMargin) - visibleWidth;
                            if (overflowWidth > 0) {
                                right += overflowWidth;
                            }
                            style.right = `${Math.max(minMargin, right)}px`;
                        }
                        filterStore.style = style;
                        filterStore.maxHeight = maxHeight;
                    });
                }
                $xeTable.dispatchEvent('filter-visible', { column, field: column.field, property: column.field, filterList: $xeTable.getCheckedFilters(), visible: filterStore.visible }, evnt);
            }
        },
        handleFilterConfirmFilter(evnt) {
            const $xeTable = this;
            const reactData = $xeTable;
            const { filterStore } = reactData;
            filterStore.options.forEach((option) => {
                option.checked = option._checked;
            });
            $xeTable.confirmFilterEvent(evnt);
        },
        _saveFilterPanel() {
            const $xeTable = this;
            $xeTable.handleFilterConfirmFilter(null);
            return $xeTable.$nextTick();
        },
        _resetFilterPanel() {
            const $xeTable = this;
            $xeTable.handleFilterResetFilter(null);
            return $xeTable.$nextTick();
        },
        _getCheckedFilters() {
            const { tableFullColumn } = this;
            const filterList = [];
            tableFullColumn.forEach((column) => {
                const { field, filters } = column;
                const valueList = [];
                const dataList = [];
                if (filters && filters.length) {
                    filters.forEach((item) => {
                        if (item.checked) {
                            valueList.push(item.value);
                            dataList.push(item.data);
                        }
                    });
                    if (valueList.length) {
                        filterList.push({ column, field, property: field, values: valueList, datas: dataList });
                    }
                }
            });
            return filterList;
        },
        handleColumnConfirmFilter(column, evnt) {
            const $xeTable = this;
            const props = $xeTable;
            const reactData = $xeTable;
            const { mouseConfig } = props;
            const { scrollXLoad: oldScrollXLoad, scrollYLoad: oldScrollYLoad } = reactData;
            const filterOpts = $xeTable.computeFilterOpts;
            const mouseOpts = $xeTable.computeMouseOpts;
            const { field } = column;
            const values = [];
            const datas = [];
            column.filters.forEach((item) => {
                if (item.checked) {
                    values.push(item.value);
                    datas.push(item.data);
                }
            });
            const filterList = this.getCheckedFilters();
            const params = { $table: this, $event: evnt, column, field, property: field, values, datas, filters: filterList, filterList };
            // 如果是服务端筛选，则跳过本地筛选处理
            if (!filterOpts.remote) {
                this.handleTableData(true);
                this.checkSelectionStatus();
            }
            if (mouseConfig && mouseOpts.area && this.handleFilterEvent) {
                $xeTable.handleFilterEvent(evnt, params);
            }
            if (evnt) {
                $xeTable.emitEvent('filter-change', params, evnt);
            }
            $xeTable.closeFilter();
            return $xeTable.updateFooter().then(() => {
                const { scrollXLoad, scrollYLoad } = this;
                if ((oldScrollXLoad || scrollXLoad) || (oldScrollYLoad || scrollYLoad)) {
                    if ((oldScrollXLoad || scrollXLoad)) {
                        $xeTable.updateScrollXSpace();
                    }
                    if ((oldScrollYLoad || scrollYLoad)) {
                        $xeTable.updateScrollYSpace();
                    }
                    return $xeTable.refreshScroll();
                }
            }).then(() => {
                $xeTable.updateCellAreas();
                return $xeTable.recalculate(true);
            }).then(() => {
                // 存在滚动行为未结束情况
                setTimeout(() => $xeTable.recalculate(), 50);
            });
        },
        /**
         * 确认筛选
         * 当筛选面板中的确定按钮被按下时触发
         * @param {Event} evnt 事件
         */
        confirmFilterEvent(evnt) {
            const $xeTable = this;
            const reactData = $xeTable;
            const { filterStore } = reactData;
            const { column } = filterStore;
            $xeTable.handleColumnConfirmFilter(column, evnt);
        },
        handleClearFilter(column) {
            if (column) {
                const { filters, filterRender } = column;
                if (filters) {
                    const compConf = isEnableConf(filterRender) ? renderer.get(filterRender.name) : null;
                    const filterResetMethod = column.filterResetMethod || (compConf ? (compConf.tableFilterResetMethod || compConf.filterResetMethod) : null);
                    filters.forEach((item) => {
                        item._checked = false;
                        item.checked = false;
                        if (!filterResetMethod) {
                            item.data = XEUtils.clone(item.resetValue, true);
                        }
                    });
                    if (filterResetMethod) {
                        filterResetMethod({ options: filters, column, $table: this });
                    }
                }
            }
        },
        /**
         * 重置筛选
         * 当筛选面板中的重置按钮被按下时触发
         * @param {Event} evnt 事件
         */
        handleFilterResetFilter(evnt) {
            this.handleClearFilter(this.filterStore.column);
            this.confirmFilterEvent(evnt);
        },
        /**
         * 清空指定列的筛选条件
         * 如果为空则清空所有列的筛选条件
         * @param {String} fieldOrColumn 列
         */
        _clearFilter(fieldOrColumn) {
            const { filterStore } = this;
            let column;
            if (fieldOrColumn) {
                column = handleFieldOrColumn(this, fieldOrColumn);
                if (column) {
                    this.handleClearFilter(column);
                }
            }
            else {
                this.visibleColumn.forEach(this.handleClearFilter);
            }
            if (!fieldOrColumn || column !== filterStore.column) {
                Object.assign(filterStore, {
                    isAllSelected: false,
                    isIndeterminate: false,
                    style: null,
                    options: [],
                    column: null,
                    multiple: false,
                    visible: false
                });
            }
            return this.updateData();
        },
        _updateFilterOptionStatus(item, checked) {
            item._checked = checked;
            item.checked = checked;
            return this.$nextTick();
        }
    }
};
